import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { restoreSession } from './api/hooks.ts';
import { AdminLayout } from './layout/AdminLayout.tsx';
import { RequireAdmin } from './layout/RequireAdmin.tsx';
import { AccountPage } from './pages/AccountPage.tsx';
import { ActivityPage } from './pages/ActivityPage.tsx';
import { ApiKeysPage } from './pages/ApiKeysPage.tsx';
import { DownloadPage } from './pages/DownloadPage.tsx';
import { ExplorePage } from './pages/explore/ExplorePage.tsx';
import { ImportsPage } from './pages/ImportsPage.tsx';
import { InvitePage } from './pages/InvitePage.tsx';
import { LoginPage } from './pages/LoginPage.tsx';
import { GameEditorPage } from './pages/games/GameEditorPage.tsx';
import { GamesPage } from './pages/games/GamesPage.tsx';
import { IndexerPage } from './pages/indexer/IndexerPage.tsx';
import { ReleasesPage } from './pages/ReleasesPage.tsx';
import { StorePage } from './pages/StorePage.tsx';
import { UsersPage } from './pages/UsersPage.tsx';

/** Routes of the web UI. */
export function App() {
  useEffect(() => {
    void restoreSession();
  }, []);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/invite/:token" element={<InvitePage />} />
      <Route path="/download" element={<DownloadPage />} />
      <Route
        path="/admin"
        element={
          <RequireAdmin>
            <AdminLayout />
          </RequireAdmin>
        }
      >
        <Route index element={<Navigate to="games" replace />} />
        <Route path="games" element={<GamesPage />} />
        <Route path="games/:id" element={<GameEditorPage />} />
        <Route path="store" element={<StorePage />} />
        <Route path="explore" element={<ExplorePage />} />
        <Route path="indexer" element={<IndexerPage />} />
        <Route path="imports" element={<ImportsPage />} />
        <Route path="api-keys" element={<ApiKeysPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="activity" element={<ActivityPage />} />
        <Route path="releases" element={<ReleasesPage />} />
      </Route>
      <Route
        element={
          <RequireAdmin>
            <AdminLayout />
          </RequireAdmin>
        }
      >
        <Route path="/account" element={<AccountPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/admin/games" replace />} />
    </Routes>
  );
}
